import { Typography, Link } from '@mui/material';
import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from "axios";
import AuthLayout from '../components/AuthLayout';
const Register = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Snackbar state
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const handleKeyDown = (key) => {
        if (key === 'Enter') {
            register();
        }
    };
    const showNotification = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setOpenSnackbar(true);
    };
    const register = () => {
        if (isSubmitting)
            return;
        if ((firstName == "") || (lastName == "") || (email == "") || (password == "") || (confirmPassword == "")) {
            showNotification("Пожалуйста, заполните все поля", "error");
            return;
        }
        if (password !== confirmPassword) {
            showNotification("Пароли не совпадают", "error");
            return;
        }
        setIsSubmitting(true);
        let data = new FormData();
        data.append('first_name', firstName);
        data.append('last_name', lastName);
        data.append('email', email);
        data.append('password', password);
        axios({
            method: "post",
            url: "/register",
            data: data,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
            if (response.data.success) {
                showNotification("Регистрация успешна! Перенаправление на страницу входа...", "success");
                setTimeout(() => {
                    window.location.href = "/login";
                }, 2000);
                return;
            }
            if (response.data.message) {
                showNotification(response.data.message, "error");
            }
            setIsSubmitting(false);
        })
            .catch(function (error) {
            showNotification("Ошибка при регистрации. Попробуйте снова.", "error");
            setIsSubmitting(false);
        });
    };
    return (React.createElement(AuthLayout, { snackbarOpen: openSnackbar, snackbarMessage: snackbarMessage, snackbarSeverity: snackbarSeverity, onCloseSnackbar: handleCloseSnackbar },
        React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: '30px' } },
                    React.createElement(Typography, { variant: 'body1' }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438.")),
                React.createElement("div", null,
                    React.createElement(Stack, { spacing: 1 },
                        React.createElement(TextField, { required: true, id: "outlined-first-name", label: "\u0418\u043C\u044F", onChange: (e) => setFirstName(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: isSubmitting }),
                        React.createElement(TextField, { required: true, id: "outlined-last-name", label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F", onChange: (e) => setLastName(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: isSubmitting }),
                        React.createElement(TextField, { required: true, id: "outlined-email", label: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", onChange: (e) => setEmail(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: isSubmitting }),
                        React.createElement(TextField, { required: true, id: "outlined-password", label: "\u041F\u0430\u0440\u043E\u043B\u044C", type: "password", autoComplete: "new-password", onKeyDown: (e) => handleKeyDown(e.key), onChange: (e) => setPassword(e.target.value), disabled: isSubmitting }),
                        React.createElement(TextField, { required: true, id: "outlined-confirm-password", label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", type: "password", autoComplete: "new-password", onKeyDown: (e) => handleKeyDown(e.key), onChange: (e) => setConfirmPassword(e.target.value), disabled: isSubmitting })),
                    React.createElement("div", { className: "submitMargin" },
                        React.createElement(Button, { onClick: () => register(), variant: "contained", disabled: isSubmitting }, "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F")),
                    React.createElement("div", { style: { marginTop: '20px', marginBottom: '50px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C?",
                            ' ',
                            React.createElement(Link, { href: "/login", style: { cursor: 'pointer' } }, "\u0412\u043E\u0439\u0442\u0438"))))))));
};
export default Register;
